import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuthedApi, formatINR } from "../../lib/api";

export default function AdminLeads() {
  const api = useAuthedApi();
  const [type, setType] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  useEffect(() => { api("get", "/admin/leads", null, { params: { type: type || undefined, page } }).then(setData); }, [api, type, page]);

  return (
    <div className="space-y-5" data-testid="admin-leads">
      <div className="flex flex-wrap gap-2 items-center">
        {[["", "All"], ["offer", "Offers"], ["enquiry", "Enquiries"]].map(([v, l]) => (
          <button key={v} onClick={() => { setPage(1); setType(v); }} className={`px-4 py-2 rounded-full text-xs font-semibold ${type === v ? "bg-[#D4AF37] text-black" : "border border-white/10 text-gray-300"}`} data-testid={`admin-leads-filter-${v || "all"}`}>{l}</button>
        ))}
        {data && <span className="text-sm text-gray-400 ml-2" data-testid="admin-leads-total">{data.total} total</span>}
      </div>
      <div className="lux-card overflow-x-auto">
        <table className="w-full text-sm min-w-[820px]">
          <thead><tr className="text-left text-[10px] uppercase tracking-widest text-gray-500 border-b border-white/5">
            <th className="p-4">When</th><th>Type</th><th>Car</th><th>Buyer</th><th>Offer</th><th className="p-4">Message</th>
          </tr></thead>
          <tbody>
            {data?.items.map((l) => (
              <tr key={l.id} className="border-b border-white/5 align-top" data-testid={`admin-lead-row-${l.id}`}>
                <td className="p-4 text-xs text-gray-400 whitespace-nowrap">{new Date(l.created_at).toLocaleString("en-IN")}</td>
                <td className="pt-4"><span className={`text-[10px] uppercase font-bold px-2 py-0.5 rounded-full ${l.type === "offer" ? "bg-[#D4AF37] text-black" : "border border-[#D4AF37]/40 text-[#E5C158]"}`}>{l.type}</span></td>
                <td className="pt-4"><Link to={`/cars/${l.listing_id}`} className="hover:text-[#E5C158]">{l.listing_title}</Link><p className="text-xs text-gray-500">asking {formatINR(l.listing_price)}</p></td>
                <td className="pt-4">{l.name}<p className="text-xs text-gray-500">{l.phone}</p></td>
                <td className="pt-4 gold-text font-semibold">{l.offer_amount ? formatINR(l.offer_amount) : "—"}</td>
                <td className="p-4 text-gray-300 max-w-xs">{l.message || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {data && !data.items.length && <p className="p-10 text-center text-gray-400">No enquiries or offers yet.</p>}
      </div>
      {data?.pages > 1 && (
        <div className="flex gap-2 justify-center">
          {Array.from({ length: data.pages }, (_, i) => i + 1).map((p) => (
            <button key={p} onClick={() => setPage(p)} className={`w-9 h-9 rounded-full text-sm ${p === page ? "bg-[#D4AF37] text-black font-bold" : "border border-white/10"}`}>{p}</button>
          ))}
        </div>
      )}
    </div>
  );
}
